// @flow
import api from 'tim-api';
import {
  viewSale,
  regionals as regionalsEndPoint,
  sale,
  segments as segmentsEndPoint
} from 'endPoints';

export const state: Object = {
  pagination: null,
  salesManagement: [],
  regionals: [],
  segments: [],
  updateSale: []
};

export const getters = {
  salesManagement: (state: Object) => state.salesManagement,
  pagination: (state: Object) => state.pagination,
  regionals: (state: Object) => state.regionals,
  segments: (state: Object) => state.segments
};

export const mutations = {
  SET_SALES_MANAGEMENT(state: Object, salesManagement: Array<Object>) {
    state.salesManagement = salesManagement;
  },
  SET_PAGINATION(state: Object, pagination: Object) {
    state.pagination = pagination;
  },
  SET_REGIONALS(state: Object, regionals: Array<Object>) {
    state.regionals = regionals;
  },
  SET_SEGMENTS(state: Object, segments: Array<Object>) {
    state.segments = segments;
  }
};

export const actions = {
  fetchSalesManagement({ commit }: Action, { page, filters, sort }: Object) {
    let url = `${sale}/gerencialSale?page=${page || 1}&${filters || ''}`;

    if (sort) {
      url += `&order=${sort.order}&sort=${sort.sort}`;
    }

    return api.get(url).then(({ data: { data, ...pagination } }) => {
      commit('SET_SALES_MANAGEMENT', data);
      commit('SET_PAGINATION', pagination);
    });
  },
  fetchRegionals({ commit }: Object) {
    api.get(regionalsEndPoint).then(({ data }) => {
      commit('SET_REGIONALS', data.data);
    });
  },
  deleteSaleManagement(store: any, id: number) {
    return api.delete(`${sale}/${id}`);
  },
  fetchSegments({ commit }: Object) {
    api.get(segmentsEndPoint).then(({ data }) => {
      commit('SET_SEGMENTS', data.data.data.segments);
    });
  },
  updateSale(context: Action, { payload, id }: Object) {
    return api.put(`${sale}/${id}`, payload);
  },
  downloadSale({ commit }: Action, filter: Object) {
    console.log('filtros dsale:', filter);
    return api
      .post('venda-cantada/gestao-vendas/exportar', filter, { responseType: 'blob' })
      .then(({ data }) => data);
  },
  downloadSaleLog({ commit }: Action, filter: Object) {
    console.log('filtros dsalelog:', filter);
    return api
      .get('venda-cantada/log-vendas/exportar' + '?' + filter, { responseType: 'blob' })
      .then(({ data }) => data);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
